export default __webpack_public_path__ + "static/media/Background_00192.8924892f.png";